<template>
  <Map></Map>
</template>

<script lang="ts" setup>
import Map from '@/components/UI/Map.vue'
</script>

<style scoped>
</style>
